import { listItemTextClasses } from '@mui/material';
import type { Components, Theme } from '@mui/material/styles';

/**
 * Оверрайд темы для бумаги меню — только радиус.
 *
 * Обводки и своей тени здесь быть не должно: `Select` рендерит свой поповер
 * через `Menu`, поэтому всё, что попадает сюда, прилетает в КАЖДЫЙ выпадающий
 * список приложения — включая экраны, к которым правка отношения не имеет
 * (проверено на `/profile`: селекты пола и семейного положения получали рамку
 * `1px solid rgba(0,0,0,0.12)` и трёхслойную тень, а при `box-sizing:
 * border-box` внутренняя ширина поповера теряла 2px — 328 против 326).
 * Оформление под конкретный фон живёт у потребителя в `slotProps.paper`
 * (см. `SortControl`).
 */
const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    /**
     * Корневые стили меню
     * @param props Пропсы
     * @param props.theme Тема
     */
    paper: ({ theme }) => ({
      borderRadius: theme.shape.borderL
    })
  }
};

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      fontSize: 16,
      fontFamily: 'Roboto',
      [`& .${listItemTextClasses.primary}`]: {
        fontSize: 16,
        fontFamily: 'Roboto'
      }
    }
  }
};

export const menu = {
  MuiMenu,
  MuiMenuItem
};
